import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { CollapseCard, NavPills } from '@totalsoft/rocket-ui';
import { Dashboard, FormatListBulleted } from '@mui/icons-material';
import SublimitHeaderComponent from './SublimitHeaderComponent';
import FlexBox from 'components/common/FlexBox';
import { SublimitsFiltersContainer } from '../../Styles';
import SublimitFiltersContainer from '../filters/SublimitFiltersContainer';

const SublimitListItemComponent = ({
  siteId,
  index,
  sublimit,
  dispatch,
  onChange,
  onSave,
  validation,
  facilityConfigurationSublimitsWrite
}) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <CollapseCard
      toggleOnHeaderClick
      title={sublimit.sublimitId ? `[${sublimit.sublimitCode}] ${sublimit.sublimitName} - ${sublimit.sublimitValue}` : t('Facility.Sublimits.New')}
      expanded={isExpanded}
      onToggle={(_, current) => setIsExpanded(!current)}
    >
      <FlexBox direction='column' gap={2}>
      <SublimitHeaderComponent
        sublimit={sublimit}
        index={index}
        dispatch={dispatch}
        onChange={onChange}
        onSave={onSave}
        validation={validation}
        facilityConfigurationSublimitsWrite={facilityConfigurationSublimitsWrite}
      />
      {sublimit.sublimitId && (
        <SublimitsFiltersContainer disablePadding>
          <NavPills
            orientation='vertical'
            tabPanelProps={{ sx: { width: '100%' } }}
            tabs={[
              {
                label: t('Facility.Sublimits.Filters.Title'),
                icon: <FormatListBulleted />,
                content: (
                  <SublimitFiltersContainer
                    siteId={siteId}
                    sublimitId={sublimit.sublimitId}
                    context='SUBLIMITFILTERS'
                    localDispatch={dispatch}
                    onSave={onSave}
                    canWrite={facilityConfigurationSublimitsWrite}
                    isExpanded={isExpanded}
                  />
                )
              },
              {
                label: t('Facility.Sublimits.FinancingStructure.Title'),
                icon: <Dashboard />,
                content: (
                  <SublimitFiltersContainer
                    siteId={siteId}
                    sublimitId={sublimit.sublimitId}
                    context='SUBLIMITFINANCINGSTRUCTUREFILTERS'
                    localDispatch={dispatch}
                    onSave={onSave}
                    canWrite={facilityConfigurationSublimitsWrite}
                    isExpanded={isExpanded}
                  />
                )
              }
            ]}
          />
        </SublimitsFiltersContainer>
      )}
      </FlexBox>
    </CollapseCard>
  );
};

SublimitListItemComponent.propTypes = {
  siteId: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  sublimit: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired,
  facilityConfigurationSublimitsWrite: PropTypes.bool
};

export default memo(SublimitListItemComponent);
